import { Box, createTheme, CssBaseline, MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { isEmbedded } from 'embedded';

/** Фирменные цвета, общие с «Домовым градусником»: акцент, его подложки, индиго шапки и рамка карточек. */
export const BRAND = {
  accent: '#005EFF',
  accentSoft: '#EBF2FF',
  accentSoftText: '#0047C2',
  ink: '#1A1A51',
  inkLight: '#24307F',
  sky: '#C2D6FF',
  line: '#E4E4E7',
};

export const theme = createTheme({
  palette: {
    background: {
      default: '#f5f5f5',
    },
    primary: {
      main: BRAND.accent,
    },
  },

  typography: {
    fontFamily: '"Gotham", Arial, sans-serif',
  },

  overrides: {
    MuiFilledInput: {
      root: {
        border: '1px solid #d9d9d9',
        borderRadius: 8,
        backgroundColor: '#f5f5f5',
        overflow: 'hidden',
        '&:before': { display: 'none' },
      },
    },
    MuiDialog: {
      paperWidthXs: {
        maxWidth: 280,
      },
    },
    MuiButton: {
      root: {
        fontSize: 14,
        borderRadius: 8,
        textTransform: 'unset',
        whiteSpace: 'nowrap',
      },
      label: {
        fontWeight: 500,
        lineHeight: '24px',
      },
      outlined: {
        backgroundColor: '#fff',
      },
    },
    MuiButtonGroup: {
      root: {
        borderRadius: 8,
      },
    },
    MuiChip: {
      root: {
        height: 'auto',
      },
      label: {
        whiteSpace: 'normal',
        padding: '6px 12px',
      },
    },
    MuiExpansionPanel: {
      rounded: {
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        borderBottomLeftRadius: 7,
        borderBottomRightRadius: 7,
      },
    },
    MuiContainer: {
      root: {
        maxWidth: 1300,
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: BRAND.ink,
        padding: '6px 0',
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: BRAND.accent,
      },
    },
    // @ts-ignore FIXME: Удалить. Исправить на местах с отрицательным margin
    MuiTabPanel: {
      root: {
        padding: '24px 0 0',
      },
    },
    MuiTableCell: {
      root: {
        padding: '10px',
      },

      footer: {
        fontSize: '0.875rem',
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
  },

  shape: { borderRadius: 8 },
});

const minWidth = isMobile ? '320px' : '1260px';

// Во фрейме нового интерфейса ширину задаёт его каркас: меню отнимает место, и минимум дал бы горизонтальную прокрутку
const MuiTheme: React.FC = ({ children }) => (
  <Box minWidth={isEmbedded ? 0 : minWidth}>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />

      {children}
    </MuiThemeProvider>
  </Box>
);

export default MuiTheme;
